/**
 * Constantes de roles del portal vecino. Sprint 12 S12-17 simplificó
 * de 6 a 4 roles del sistema (super_admin, vecino, comision,
 * tesorero). `comision_gestion` fusionado en `comision`;
 * `propietario_no_residente` dejó de ser rol del sistema.
 */

// Roles que pueden actuar como "admin del barrio" desde el portal
// vecino (sección /admin/*).
export const ROLES_ADMIN: string[] = ['comision', 'tesorero'];

// Roles que pueden aprobar/rechazar solicitudes de acceso públicas.
// Sprint 12 S12-17: comision absorbe comision_gestion.
export const ROLES_REVISAN_SOLICITUDES: string[] = ['comision'];

// Roles que publican contenido (documentos y avisos del barrio).
// Sprint 13 S13-06: matriz por verbo (S12-17) — exclusivo comision.
export const ROLES_PUBLICAN_CONTENIDO: string[] = ['comision'];

// Roles que OPERAN suspensiones por casa (transiciones de la máquina de
// estados: suspender / confirmar corte / reactivar / confirmar reconexión).
// Sprint 19a: solo tesorero (escritura).
export const ROLES_SUSPENDEN: string[] = ['tesorero'];

// Roles que VEN suspensiones por casa (lectura: gate de ruta + visibilidad de
// menú). Sprint 19a: comisión lee read-only (sin botones), tesorero opera.
export const ROLES_VEN_SUSPENSIONES: string[] = ['comision', 'tesorero'];

// Reprogramación de accesos en el HW (origen: cambio de dato del vecino, no
// morosidad). Pantalla separada de Suspensiones. Comisión lee, tesorero opera.
export const ROLES_VEN_REPROGRAMACION: string[] = ['comision', 'tesorero'];
export const ROLES_REPROGRAMAN: string[] = ['tesorero'];

// Roles que gestionan solicitudes de eliminación de cuenta (Ley 21.719,
// P10). Coherente con require_comision del backend (comisión estricta).
export const ROLES_GESTIONAN_DATOS: string[] = ['comision'];

export function tieneAlgunRol(
  rolesUsuario: string[],
  rolesRequeridos: string[],
): boolean {
  return rolesRequeridos.some((rol) => rolesUsuario.includes(rol));
}
